import getApiClient from '@/plugins/api-client'

export default {
  loadOrder: function () {
    const api = getApiClient(this.$store)
    const orderId = this.$route.params.id

    api.get(`orders/${orderId}`)
      .then(result => {
        this.order = result.data
      })
      .catch(error => {
        this.error = error
      })
  },
}
